import { AxiosResponse } from 'axios';


class AxiosResponseOk implements AxiosResponse {
  data: any;
  status = 200;
  statusText = '';
  headers: any = {};
  config: any = {};

  constructor(data: any) {
    this.data = data;
  }
}

export { AxiosResponseOk }
